/**
 * Shared brand backdrop used by the login/auth shell and the public
 * /apps gallery. Two absolutely-positioned aria-hidden layers: a
 * dot-grid with a soft primary glow up top, and a bottom band fading
 * in the brand image. Both respect the theme tokens.
 *
 * Kept as a single component so the two surfaces can't drift apart.
 * The layers render at AUTO z-index (no -z-10) so they paint over the
 * parent's bg-background — siblings after BrandBackdrop in the DOM
 * naturally paint on top of the dots. Using -z-10 here would push the
 * layers behind the parent's own background and hide them entirely.
 */
export function BrandBackdrop() {
  return (
    <>
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-background
                   [background-image:radial-gradient(circle,_var(--color-border)_1px,_transparent_1px),radial-gradient(ellipse_at_top_right,_color-mix(in_oklab,_var(--color-primary)_8%,_transparent),_transparent_70%)]
                   [background-size:20px_20px,_100%_100%]
                   [background-position:0_0,_0_0]
                   dark:[background-image:radial-gradient(circle,_color-mix(in_oklab,_var(--color-border)_70%,_transparent)_1px,_transparent_1px),radial-gradient(ellipse_at_top_right,_color-mix(in_oklab,_var(--color-primary)_18%,_transparent),_transparent_70%)]"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-cover bg-center bg-no-repeat
                   bg-[url('/bg/login-bg-light.jpg')] dark:bg-[url('/bg/login-bg-dark.jpg')]
                   [filter:contrast(0.95)_saturate(0.9)]
                   [mask-image:linear-gradient(to_bottom,_transparent_0%,_black_60%)]
                   [-webkit-mask-image:linear-gradient(to_bottom,_transparent_0%,_black_60%)]"
      />
    </>
  );
}
